// Entity-header overflow menu — the 3-dot trigger that hides on
// desktop and reveals the header's actions inside a dropdown at narrow
// widths. Auto-binds to any [data-entity-menu] container; no per-page
// wiring needed.
"use strict";

(function () {
  function init() {
    var menus = document.querySelectorAll('[data-entity-menu]');
    if (!menus.length) return;

    Array.prototype.forEach.call(menus, function (menu) {
      var trigger = menu.querySelector('.entity-header__menu-trigger');
      var list = menu.querySelector('.entity-header__menu-list');
      if (!trigger || !list) return;

      function open() {
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
      function close() {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (list.hidden) open(); else close();
      });

      // Click outside closes. Listen on document and check containment.
      document.addEventListener('click', function (e) {
        if (list.hidden) return;
        if (!menu.contains(e.target)) close();
      });

      // Escape closes.
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !list.hidden) close();
      });

      // Clicking a menu item navigates (the <a> default) and closes.
      list.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('a')) close();
      });
    });
  }

  // Generic [data-toggle-target] click handler — flips `hidden` on the
  // element whose id matches the attribute, and mirrors the state to
  // aria-expanded on the trigger. Used by Team-tab + person / + agent
  // buttons, and any future "click this to reveal that" affordance.
  function initToggleTargets() {
    var triggers = document.querySelectorAll('[data-toggle-target]');
    if (!triggers.length) return;
    Array.prototype.forEach.call(triggers, function (btn) {
      var targetId = btn.getAttribute('data-toggle-target');
      var target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var willOpen = target.hidden;
        target.hidden = !willOpen;
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initToggleTargets();
    });
  } else {
    init();
    initToggleTargets();
  }
})();
